import { useContext, useCallback } from 'react';
import IsFeatureEnabledContext from 'components/contexts/is_feature_enabled';

import { isFeatureOverridden, registerFeatureOverrideConsoleHelpers } from './feature_overrides';

registerFeatureOverrideConsoleHelpers();

export default function useIsFeatureEnabled() {
  const appFeatures = useContext(IsFeatureEnabledContext);

  return useCallback(
    feature => {
      if (isFeatureOverridden(feature)) {
        return true;
      }
      return (appFeatures && appFeatures.isEnabled(feature)) || false;
    },
    [appFeatures]
  );
}
